var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Address",
    transform: "translate(-156 -236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "place-24px",
    transform: "translate(156 236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M0,0H15V15H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M9.375,2A4.372,4.372,0,0,0,5,6.375C5,9.656,9.375,14.5,9.375,14.5S13.75,9.656,13.75,6.375A4.372,4.372,0,0,0,9.375,2Zm0,5.937a1.562,1.562,0,1,1,1.562-1.562A1.563,1.563,0,0,1,9.375,7.937Z",
    transform: "translate(-1.875 -0.75)",
    fill: "#848484"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.7a24e4136dbe65e78ee0928fcde4a76f.svg";
export { ForwardRef as ReactComponent };